import TextField from 'components/TextField';
import Form from 'components/Form';
import { Col } from 'reactstrap';
import RadioChoicesFiled from 'components/RadioChoicesField';
import SelectField from 'components/SelectField';
import DateField from 'components/DateField';
import CampaignLayout from 'enum/CampaignLayout';
import {
  LabelFullScreen,
  LabelHalfSplit,
  LabelHorizontallySplit,
  LabelVerticallySplit
} from '../CampaignLabels';
import ScreenOrientation from 'enum/ScreenOrientation';
import useControllerCampaignCreatePage from './_presenters/useControllerCampaignCreatePage/useControllerCampaignCreatePage';
import apiPaths from 'constants/apiPaths';
import FixedHeader from 'components/FixedHeader';

const CampaignCreatePage = () => {
  const {
    formMethods,
    onSubmitHandler,
    typeOptionsOrientation,
    goOut,
    canSubmit
  } = useControllerCampaignCreatePage();

  const typeOptionsScreen = [
    { value: CampaignLayout.FULL_SCREEN, label: <LabelFullScreen /> },
    {
      value: CampaignLayout.HORIZONTALLY_SPLIT,
      label: <LabelHorizontallySplit />
    },
    { value: CampaignLayout.VERTICALLY_SPLIT, label: <LabelVerticallySplit /> },
    { value: CampaignLayout.HALF_SCREEN, label: <LabelHalfSplit /> }
  ];
  const typeOptionsActive = [
    { value: true, label: 'Ativo' },
    {
      value: false,
      label: 'Inativo'
    }
  ];

  const breadcrumbs = [
    { label: 'Tv Corporativa', path: apiPaths.tvCorporate },
    { label: 'Campanha', path: apiPaths.tvCorporate }
  ];

  return (
    <>
      <FixedHeader
        breadcrumbs={breadcrumbs}
        title="Campanha"
        smallDescription="Realize as configurações da sua campanha."
        onBack={goOut}
        canSubmit={canSubmit}
        onSave={() => {
          formMethods.handleSubmit(onSubmitHandler)();
        }}
        canPerformAction={true}
      />
      <div className="mx-3 page-scroll">
        <Form onSubmit={onSubmitHandler} {...formMethods}>
          <div className="shadow bg-white form">
            <Col className="mx-4 mt-3">
              <TextField label="Nome" name="name" />
              <RadioChoicesFiled
                label="Tipo de tela"
                name="layoutType"
                options={typeOptionsScreen}
                classNameRadio="d-flex flex-wrap justify-content-between"
                defaultValue={CampaignLayout.FULL_SCREEN}
              />
              <SelectField
                label="Orientação visual"
                name="screenOrientation"
                options={typeOptionsOrientation}
                defaultValue={ScreenOrientation.PORTRAIT}
              />
              <SelectField
                name="active"
                label="Status"
                options={typeOptionsActive}
                defaultValue={String(true)}
              />
              <div className="row">
                <div className="col-12 col-md-6">
                  <DateField
                    label="Data e hora de Início"
                    name="startDate"
                    type="datetime-local"
                  />
                </div>
                <div className="col-12 col-md-6">
                  <DateField
                    label="Data e hora de termino"
                    name="endDate"
                    type="datetime-local"
                  />
                </div>
              </div>
            </Col>
          </div>
        </Form>
      </div>
    </>
  );
};

export default CampaignCreatePage;
